<template>
  <div class="bg">
    <van-search v-model="keyword" placeholder="请输入搜索关键词" @search="search" @focus="handleFocusSearch" @blur="handleBlurSearch" />
    <van-cell-group v-if="showHistory" style="position: absolute; width: 100%; max-height: 200px; overflow-y: scroll;">
      <van-cell :title="history" v-for="history in histories" :key="history" @click="clickHistory(history)"/>
      <van-cell v-if="histories.length > 0" @click="clearKeywordHistory"><a style="width: 100%; text-align: center; color: #a8a8a8">清除历史记录</a></van-cell>
    </van-cell-group>
<!--    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">-->
<!--      <van-swipe-item>1</van-swipe-item>-->
<!--      <van-swipe-item>2</van-swipe-item>-->
<!--      <van-swipe-item>3</van-swipe-item>-->
<!--      <van-swipe-item>4</van-swipe-item>-->
<!--    </van-swipe>-->
    <van-row span="24" class="vod-container">
      <van-tabs @change="handleTab">
        <van-tab title="视频点播">
          <van-col span="8" v-for="(movie, index) in movies" :key="movie.name + '-' + index" @click="showDetail(movie)">
            <VodInfo :info="movie" :is-proxy="true"></VodInfo>
          </van-col>
        </van-tab>
        <van-tab title="直播频道">
        </van-tab>
      </van-tabs>
    </van-row>
  </div>
</template>

<script>
import { getVodRank, getVodSources } from '@/api/vod'
import VodInfo from '@/components/blocks/vod/VodInfo'
import { Base64 } from 'js-base64'

export default {
  name: 'VodHome',
  components: {
    VodInfo
  },
  data () {
    return {
      showHistory: false,
      movies: [],
      sources: [],
      keyword: '',
      histories: []
    }
  },
  methods: {
    getVodRank () {
      getVodRank({}).then(res => {
        this.movies = res.result
        this.$parent.progressOff()
      })
    },
    getVodSources () {
      getVodSources({}).then(res => {
        this.sources = res.result
        window.localStorage.setItem('vod_sources', JSON.stringify(this.sources))
      })
    },
    showDetail (movie) {
      if (!this.$parent.isVip()) {
        return false
      }
      if (movie.sourceKey !== '') {
        location.href = '/#/in-app/vod/detail/' + movie.sourceKey + '/' + movie.id
      } else {
        location.href = '/#/in-app/vod/result/' + Base64.encode(movie.name).replaceAll('/', '_') + '/acc'
      }
    },
    search () {
      if (!this.$parent.isVip()) {
        return false
      }
      this.addKeywordHistory()
      location.href = '/#/in-app/vod/result/' + Base64.encode(this.keyword).replaceAll('/', '_')
    },
    getKeywordHistory () {
      this.histories = JSON.parse(window.localStorage.getItem('vod_keyword_history') || '[]')
      console.log(this.histories)
    },
    addKeywordHistory () {
      let flag = true
      this.histories.forEach(v => {
        if (v === this.keyword) {
          flag = false
        }
      })
      if (flag) {
        this.histories = this.histories.reverse()
        this.histories.push(this.keyword)
        this.histories = this.histories.reverse()
        window.localStorage.setItem('vod_keyword_history', JSON.stringify(this.histories))
      }
    },
    clearKeywordHistory () {
      console.log('clearKeywordHistory')
      window.localStorage.removeItem('vod_keyword_history')
    },
    clickHistory (item) {
      this.keyword = item
      this.search()
    },
    handleFocusSearch () {
      this.getKeywordHistory()
      this.showHistory = true
    },
    handleBlurSearch () {
      setTimeout(() => {
        this.showHistory = false
      }, 100)
    },
    handleTab (index, name) {
      if (index === 1) {
        location.href = '/#/in-app/vod/live'
      }
    },
    change () {
      this.getVodRank()
      this.getVodSources()
    }
  },
  mounted () {
    this.change()
  }
}
</script>

<style lang="less">

.bg {
  background-color: #f3f3f3;
  width: 100vw;
  height: 100vh;
  overflow-y: hidden;
}

.vod-container {
  height: calc(100vh - 120px);
  overflow-y: scroll;
  margin-top: 10px;
}

.my-swipe  {
  .van-swipe-item {
    color: #fff;
    font-size: 20px;
    line-height: 150px;
    text-align: center;
    background-color: #39a9ed;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/inApp/Vod/Home.vue